import styled from 'styled-components';

import { defaultColor, radius } from 'styles/theme';

export const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: ${defaultColor('backgroundLight')};
  }

  &:focus-visible {
    outline: 2px solid ${defaultColor('dark')};
    outline-offset: 1px;
  }
`;

export const Dots = styled.span`
  display: flex;
  flex-direction: column;
  gap: 3px;

  span {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: ${defaultColor('gray')};
  }
`;

export const Menu = styled.div`
  position: fixed;
  z-index: 50;
  min-width: 168px;
  padding: 4px;
  background: ${defaultColor('white')};
  border: 1px solid ${defaultColor('background')};
  border-radius: ${radius('small')};
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;

  a,
  button {
    display: block;
    width: 100%;
    text-align: left;
    padding: 9px 12px;
    border: none;
    background: transparent;
    color: ${defaultColor('dark')};
    font: inherit;
    font-size: 13px;
    text-decoration: none;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      background: ${defaultColor('backgroundLight')};
    }
  }

  button:disabled {
    color: ${defaultColor('metallic')};
    cursor: default;

    &:hover {
      background: transparent;
    }
  }
`;
